import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { API_BASE_URL } from '../../api';
import Select from 'react-select';
import { priceInWords } from '../../Helpers'
// import { convertToWords } from 'react-number-to-words';
// import {NumberInput, NumberDisplay} from 'react-number-to-words';



const Add_project = () => {
    const [formData, setFormData] = useState({
        client_id: '',
        project_name: '',
        start_date: '',
        end_date: '',
        amount: '',
        status: 'onhold',
        package: '',
        remarks: '',
        agent: 'MEET',
        renewal_month: '1',
        amount_in_word: '',
    });

    const [amountInWord, setAmountInWord] = useState([]);
    const [clients, setClients] = useState([]);
    const headers = {
        authorization: "Bearer " + localStorage.getItem("authToken"),
        user_id: localStorage.getItem("userId"),
    };

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/client`, { headers });
                setClients(response.data);
            } catch (error) {
                console.error('Error fetching clients:', error.response?.data || error.message);
            }
        };

        fetchClients();
    }, []);

    // Create options from clients
    const clientOptions = useMemo(
        () =>
            clients.map((client) => ({
                value: client.id,
                label: client.full_name,
            })),
        [clients]
    );

    // Handler for react-select components
    const handleSelectChange = (selectedOption, actionMeta) => {
        setFormData((prevData) => ({
            ...prevData,
            [actionMeta.name]: selectedOption ? selectedOption.value : '',
        }));
    };

    // Handler for standard input fields
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const numberChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setAmountInWord(priceInWords(value));
        console.log(priceInWords(value));
        // amountinword.html()
    };




    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${API_BASE_URL}/api/project`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    ...headers,
                },
            });
            Swal.fire({
                icon: 'success',
                title: 'Project Added',
                text: 'The project has been added successfully!',
            }).then(() => {
                window.location.reload();
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Failed to add project: ${error.response?.data?.message || error.message}`,
            });
        }
    };

    // Create selected option object for the client select
    const selectedClientOption = clientOptions.find(
        (option) => option.value === formData.client_id
    ) || null;

    return (
        <div className="modal fade" id="add_project" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content text-start">
                    <div className="modal-header header-border align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <h5 className="modal-title me-2">Add Project</h5>
                        </div>
                        <button
                            type="button"
                            className="btn-close custom-btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                    <div className="add-info-fieldset">
                        <fieldset id="first-field-file">
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Client Name</label>
                                                <Select
                                                    options={clientOptions}
                                                    name="client_id"
                                                    value={selectedClientOption}
                                                    onChange={handleSelectChange}
                                                    placeholder="Select Client"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Project Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="project_name"
                                                    value={formData.project_name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6 mb-3">
                                            <label className="form-label">Start Date</label>
                                            <input
                                                type="date"
                                                name="start_date"
                                                value={formData.start_date}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                        <div className="col-6 mb-3">
                                            <label className="form-label">End Date</label>
                                            <input
                                                type="date"
                                                name="end_date"
                                                value={formData.end_date}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                        <div className="col-6 mb-3">
                                            <label className="form-label">Amount</label>
                                            <input
                                                type="number"
                                                name="amount"
                                                value={formData.amount}
                                                onChange={numberChange}
                                                className="form-control"
                                                required
                                            />
                                            <span id="amountinword">{amountInWord}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Status</label>
                                                <select
                                                    className="form-control"
                                                    name="status"
                                                    value={formData.status}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="pending">Pending</option>
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                    <option value="onhold">On Hold</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Select Agent</label>

                                                <select
                                                    className="form-control"
                                                    name="agent"
                                                    value={formData.agent}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select Agent</option>
                                                    <option value="MEET">Meet</option>
                                                    <option value="BRIJESH">Brijesh</option>
                                                    <option value="NISHANTSIR">Nishant Sir</option>
                                                    <option value="CHIRAG">Chirag</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-6 mb-3">
                                            <label className="form-label">Renewal Month</label>
                                            <input
                                                type="number"
                                                name="renewal_month"
                                                value={formData.renewal_month}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Package</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                name="package"
                                                value={formData.package}
                                                onChange={handleInputChange}
                                            ></textarea>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Remarks</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                name="remarks"
                                                value={formData.remarks}
                                                onChange={handleInputChange}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <div className="d-flex align-items-center justify-content-end">
                                        <button
                                            type="button"
                                            className="btn btn-outline-light border me-2"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </button>
                                        <button className="btn btn-primary" type="submit">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Add_project;
